import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  iconWrapper: {
    display: 'block',
    margin: '0 auto',
    '& svg': {
      width: 120,
      height: 120,
    },
  },
  content: {
    marginBottom: 16,
    textAlign: 'center',
  },
  contentWrapper: {
    [breakpoints.up('md')]: {
      paddingLeft: 44,
      paddingRight: 44,
    },
  },
  title: {
    textAlign: 'center',
    [breakpoints.up('md')]: {
      paddingLeft: 44,
      paddingRight: 44,
    },
  },
}));
